import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import StepThreeExamInfo from './StepThreeExamInfo'
import { InputField } from 'components/shared/InputField'
import DatePickerField from 'components/shared/DatePickerField'
import { changeToIst } from 'utils/dateTime'

import useGetApi from 'api/useGetApi'
import config from 'config'
import SelectCreatable from 'utils/SelectDropdown'
import { getIPData, getIPLepton } from 'api/api'
import { useSelector } from 'react-redux'
import { getExamType } from 'utils/common'

const StepTwoUserInfo = ({
    registration_page,
    defaultUserInfo,
    isNewUser,
    userMethod,
    setSignupSuccessDetails,
}) => {
    const { mobileNumber } = defaultUserInfo
    const examType = getExamType()
    const utmParams = JSON.parse(sessionStorage.getItem('utmParams'))

    const [geolocationData, setGeolocation] = useState()

    const [userInfo, setUserInfo] = useState(defaultUserInfo)

    const [errorMsg, setErrorMsg] = useState({
        studentName: '',
        // fatherName: '',
        email: '',
        dob: '',
    })

    const [examInfo, setExamInfo] = useState({
        schoolBoard: { value: 'CBSE', label: 'CBSE' },
        classStream: '',
        examSlots: '',
        state: '',
        centre: '',
        dateOfExam: '',
    })

    const [dropdownOptions, setDropdownOptions] = useState({
        schoolBoard: [],
        classStream: [],
        state: [],
        centre: [],
        dateOfExam: [],
        examSlots: [],
    })

    const [errors, setErrors] = useState({
        schoolBoard: '',
        classStream: '',
        state: '',
        centre: '',
        dateOfExam: '',
    })


    const isNeetMockRoute = "MOCK-NEET" === examType;

    // API hooks to fetch dropdown options
    const { data: schoolBoardData } = useGetApi(config.FETCH_SCHOOL_BOARD, '', true)
    const { data: classStreamData } = useGetApi(
        config.FETCH_CLASS_STREAM + '/?registration_page=' + registration_page,
        '',
        true,
    )

    const { data: nearestCentreData, setEnabled: getNearestCentre } = useGetApi(
        `${config.NEAREST_CENTRE}/${geolocationData?.latitude}/${geolocationData?.longitude}/${examInfo.classStream.value}/Online`,
        '',
        false,
    )

    const [isFormValid, setIsFormValid] = useState(false)
    const [isExamDetailsFormVisible, setExamDetailsFormVisibile] = useState(false)

    useEffect(() => {
        const userInfoValues = Object.values(userInfo).some((val) => val === '')
        const errorValues = Object.values(errorMsg).some((val) => val)

        setIsFormValid(!userInfoValues && !errorValues)
    }, [userInfo, errorMsg])

    useEffect(() => {
        if (
            isFormValid &&
            examInfo.schoolBoard !== '' &&
            examInfo.classStream !== ''
        ) {
            /**
             * show Exam details form when userInfo &
             * Board, class&stream (2 fields of examInfo) dropdowns are filled
             * with no errors
             */
            setExamDetailsFormVisibile(true)
        }

        // todo version 2: call API to save userInfo
    }, [isFormValid, examInfo, errors])

    useEffect(() => {
        if (isExamDetailsFormVisible) {
            const {
                studentName: student_name,
                fatherName: father_name,
                email: email_ID,
                dob,
            } = userInfo

            // weub-analytics
            if (examType == "iACST") {
                window.webengage.track('iACST_2_Student_Info', {
                    'utm parameters': utmParams,
                    method: userMethod.isPsid ? 'psid' : 'mobile',
                    psid: userMethod.psid,
                    'mobile number': mobileNumber,
                    board: examInfo.schoolBoard.value,
                    student_name,
                    father_name,
                    email_ID,
                    dob: changeToIst(dob),
                })
            }

            window.webengage.user.setAttribute('we_first_name', student_name)
            window.webengage.user.setAttribute('we_email', email_ID)

            window.dataLayer.push({
                event: 'iacst_registration_mobile_number',
                mobile_no: userInfo.mobileNumber,
            })

            window.dataLayer.push({
                event: 'iacst_registration_email',
                email: userInfo.email,
            })

            window.dataLayer.push({
                event: 'iacst_registration_board',
                board: examInfo.schoolBoard.value,
            })
            // fired when user select class and stream
            window.dataLayer.push({
                event: 'iacst_class_stream',
                class: examInfo.classStream.class,
                stream:examInfo.classStream.stream.split('&')[1]
            })
        }
    }, [isExamDetailsFormVisible])

    // useEffect(() => {
    //     if (schoolBoardData?.success && schoolBoardData?.data.length) {
    //         setDropdownOptions({
    //             ...dropdownOptions,
    //             schoolBoard: schoolBoardData?.data,
    //         })
    //     }
    // }, [schoolBoardData])

    useEffect(() => {
        if (classStreamData?.success && Object.keys(classStreamData?.data).length) {
            const classData = classStreamData?.data
            const classStreamOptions = []
            for (const key in classData) {
                if (Object.prototype.hasOwnProperty.call(classData, key)) {
                    classStreamOptions.push({
                        label: classData[key].display_name,
                        value: key,
                        stream: classData[key].stream,
                        class: classData[key].stream.split('&')[0],
                    })
                }
            }

            classStreamOptions.sort((a, b) => a.class - b.class)

            setDropdownOptions({
                ...dropdownOptions,
                classStream: classStreamOptions,
            })
        }
    }, [classStreamData])

    useEffect(() => {
        const localStorage = window.localStorage
        const locData = localStorage.getItem('iacst_location')
        const parsedLoc = locData ? JSON.parse(locData) : {}
        if (parsedLoc.revalidation > Date.now()) {
            const { longitude, latitude, isLocationAllowed, city, pincode, state } =
                parsedLoc
            setGeolocation({
                longitude,
                latitude,
                isLocationAllowed: isLocationAllowed,
            })
            setUserInfo((s) => ({ ...s, city, pincode, state }))
        } else {
            getIP()
            navigator.geolocation.getCurrentPosition(({ coords }) => {
                const { longitude, latitude } = coords
                getIP({ longitude, latitude })

                setGeolocation({ longitude, latitude, isLocationAllowed: true })
            })
        }
    }, [])

    useEffect(() => {
        if (
            geolocationData?.longitude &&
            geolocationData?.latitude &&
            geolocationData?.isLocationAllowed &&
            examInfo.classStream
        ) {
            getNearestCentre(true)
        }
    }, [examInfo.classStream, geolocationData, getNearestCentre])

    useEffect(() => {
        if (nearestCentreData) {
           
            if (nearestCentreData?.data?.length > 0) {
                const {
                    data: [{ state_code: state, center_name: centre }],
                } = nearestCentreData
                setExamInfo((s) => ({
                    ...s,
                    ...(!s.state
                        ? { autoFill: { state, centre } }
                        : { nearest: { state, centre } }), // stop resetting of "centre" state on "state" state change
                }))
            } else {
                console.error('No centre found')
            }
        }
    }, [nearestCentreData])

    const getIP = async (locationAccess) => {
        try {
            if (locationAccess) {
                const { data } = await getIPLepton(locationAccess)
                const { city, state, pincode } = data

                const geoloc = {
                    ...locationAccess,
                    city,
                    pincode,
                    state,
                    isLocationAllowed: true,
                }
                setUserInfo((s) => ({ ...s, city, pincode, state }))

                localStorage.setItem(
                    'iacst_location',
                    JSON.stringify({
                        ...geoloc,
                        revalidation: Date.now() + 5184000,
                    }),
                )
            } else {
                const { data } = await getIPData()
                const { longitude, latitude, city, postal, region } = data

                const geoloc = {
                    longitude,
                    latitude,
                    city,
                    pincode: postal,
                    state: region,
                    isLocationAllowed: false,
                }
                setGeolocation(() => geoloc)
                setUserInfo((s) => ({ ...s, city, pincode: postal, state: region }))

                localStorage.setItem(
                    'iacst_location',
                    JSON.stringify({
                        ...geoloc,
                        revalidation: Date.now() + 5184000,
                    }),
                )
            }
        } catch (error) {
            console.error(error)
        }
    }

    const handleFormDataChange = (event) => {
    const { name, value } = event.target;

    if (name === 'studentName') {
        // Allow only alphabets and spaces
        const alphabetOnly = value.replace(/[^a-zA-Z\s]/g, '');

        // Restrict dots and other special chars
        if (alphabetOnly.includes('.')) {
            return;
        }

        const sanitizedValue = alphabetOnly
            .split('')
            .map((char, index) => {
                // prevent spaces at first two characters
                if (index < 2 && char === ' ') {
                    return '';
                }
                return char;
            })
            .join('');

        setUserInfo({ ...userInfo, [name]: sanitizedValue });

        if (errorMsg[name]) {
            setErrorMsg((preErrorStates) => ({
                ...preErrorStates,
                [name]: '',
            }));
        }
        return; // stop here so that below logic doesn’t apply to other fields
    }

    // for other fields (email, etc.)
    setUserInfo({ ...userInfo, [name]: value });

    if (errorMsg[name]) {
        setErrorMsg((preErrorStates) => ({
            ...preErrorStates,
            [name]: '',
        }));
    }
};

    const handleDobChange = (date) => {
        setUserInfo({ ...userInfo, dob: date })

        setErrorMsg({
            ...errorMsg,
            dob: '',
        })
    }

    const handleOnChange = ({ name, value }) => {
        setExamInfo((s) => ({
            ...s,
            [name]: value,
            ...( (name === 'state' || name === 'centre') && { autoFill: false } ),

            ...(name === 'state' &&
                s.state !== '' && { centre: '', dateOfExam: '' }),
            ...(name === 'centre' && s.centre !== '' && { dateOfExam: '' }),
        }))
    }


    const handleErrorsOnChangeCourseType = () => {
        setErrors((err) => ({
            ...err,
            state: '',
            centre: '',
            dateOfExam: '',
        }))
    }

    const handleUpdateErrors = (name, error) => {
        const MIN_NAME_LENGTH = 2
        if (name.length < MIN_NAME_LENGTH) {
            return 'Minimum length should be 2'
        }
        setErrorMsg((err) => ({
            ...err,
            [name]: error,
        }))

        // only trigger WebEngage event when `error` value is not empty
        if (error) {
            const fieldErrors = { ...errorMsg, [name]: error }

            // web-analytics
            const {
                studentName: student_name,
                // fatherName: father_name,
                email: email_ID,
                dob,
                schoolBoard: Board,
            } = fieldErrors

            if (examType == "iACST") {
                window.webengage.track(examType+'_2_Student_Info_Error', {
                    'utm parameters': utmParams,
                    method: userMethod.isPsid ? 'psid' : 'mobile',
                    psid: userMethod.psid,
                    'mobile number': mobileNumber,
                    error_fields: {
                        Board,
                        student_name,
                        // father_name,
                        email_ID,
                        dob: changeToIst(dob),
                        exam_type:examType
                    },
                })
            }
        }
    }

    const handleExamErrors = (name, error) => {
        setErrors((err) => ({
            ...err,
            [name]: error,
        }))

        // only trigger WebEngage event when `error` value is not empty
        if (error) {
            const fieldErrors = { ...errors, [name]: error }
            const {
                classStream: Class_n_Stream,
                state: State,
                centre: Center,
                dateOfExam: Exam_Date,
            } = fieldErrors

            // web-analytics
            if (examType == "iACST") {
                window.webengage.track('iACST_3_Exam_Details_Error', {
                    'utm parameters': utmParams,
                    method: userMethod.isPsid ? 'psid' : 'mobile',
                    'mobile number': userInfo.mobileNumber,
                    error_fields: {
                        Class_n_Stream,
                        State,
                        Center,
                        Exam_Date,
                    },
                })
            }
        }
    }

    const handleDobOnBlur = (userSelectedDob, event = 'select') => {
        if (userSelectedDob === '' || userSelectedDob === null)
        setErrorMsg({ ...errorMsg, dob: 'Please select date of birth' })
    }

    const getSelectDefaultValue = (value, array, key = 'value') => {
        if (value === '') return false

        const isPresent = array.find(
            (a) =>
                a?.value.toString().toLowerCase() ===
                value?.value.toString().toLowerCase() ||
                a?.[key].toString().toLowerCase() ===
                value?.value.toString().toLowerCase(),
        )
        if (isPresent) return isPresent
        return false
    }

    return (
        <div className="pb-2">
            <InputField
                required
                placeholder="Student name"
                name="studentName"
                validation="name"
                messages={{
                    required: 'Please enter student name',
                    studentName: errorMsg.studentName,
                }}
                type="text"
                value={userInfo.studentName}
                onChange={handleFormDataChange}
                showErrorOn="blur"
                onErrorUpdate={handleUpdateErrors}
                disabled={!isNewUser}
                classNames="px-lg-4 px-3"
            />

            {isNeetMockRoute && (
                <InputField
                    required
                    placeholder="Father name"
                    name="fatherName"
                    validation="name"
                    messages={{
                        required: 'Please enter father name',
                        studentName: errorMsg.fatherName,
                    }}
                    type="text"
                    value={userInfo.fatherName}
                    onChange={handleFormDataChange}
                    showErrorOn="blur"
                    onErrorUpdate={handleUpdateErrors}
                    disabled={!isNewUser}
                    classNames="px-lg-4 px-3"
                />
            )}

            <InputField
                required
                placeholder="Email ID"
                name="email"
                validation="email"
                messages={{
                    required: 'Please enter email',
                    studentName: errorMsg.email,
                }}
                type="text"
                value={userInfo.email}
                onChange={handleFormDataChange}
                showErrorOn="blur"
                onErrorUpdate={handleUpdateErrors}
                disabled={!isNewUser}
                classNames="px-lg-4 px-3"
            />

            <DatePickerField
                value={userInfo.dob}
                onChange={handleDobChange}
                onBlur={handleDobOnBlur}
                placeholder="Enter Date of birth (DD/MM/YYYY)"
                errorMsg={errorMsg.dob}
                disabled={!isNewUser}
                classNames="px-lg-4 px-3"
            />

            {/* <SelectCreatable
                required
                placeholder="School Board"
                name="schoolBoard"
                options={dropdownOptions.schoolBoard}
                value={getSelectDefaultValue(
                    examInfo.schoolBoard,
                    dropdownOptions.schoolBoard,
                )}
                onChange={handleOnChange}
                onErrorUpdate={handleExamErrors}
                messages={{
                    required: 'Please select your Board',
                }}
                isSearchable={false}
                className="mb-3 px-3"
                outerDivStyles={`w-100 font-size-sm rounded box-shadow-none ${
                    errors.schoolBoard ? `border-0` : `border border-grey-100`
                }`}
                placeholderStyles={{ color: '#545454' }}
                borderStyles={`2px solid #00b0f5 !important`}
            /> */}

            <SelectCreatable
                required
                placeholder="Class & stream"
                name="classStream"
                options={dropdownOptions.classStream}
                value={getSelectDefaultValue(
                    examInfo.classStream,
                    dropdownOptions.classStream,
                )}
                onChange={handleOnChange}
                onErrorUpdate={handleExamErrors}
                messages={{
                    required: 'Please select class & stream',
                }}
                isSearchable={false}
                className="mb-3 px-lg-4 px-3"
                outerDivStyles={`w-100 font-size-sm rounded box-shadow-none ${errors.classStream ? `border-0` : `border border-grey-100`
                    }`}
                placeholderStyles={{ color: '#545454' }}
                borderStyles={`2px solid #00b0f5 !important`}
            />

            {isExamDetailsFormVisible && (
                <StepThreeExamInfo
                    userInfo={userInfo}
                    userMethod={userMethod}
                    isUserInfoValid={isFormValid}
                    setSignupSuccessDetails={setSignupSuccessDetails}
                    examInfo={examInfo}
                    setExamInfo={setExamInfo}
                    dropdownOptions={dropdownOptions}
                    setDropdownOptions={setDropdownOptions}
                    errors={errors}
                    handleOnChange={handleOnChange}
                    getNearestCentre={getNearestCentre}
                    handleUpdateErrors={handleExamErrors}
                    getSelectDefaultValue={getSelectDefaultValue}
                    registration_page={registration_page}
                    handleErrorsOnChangeCourseType={handleErrorsOnChangeCourseType}
                />
            )}
        </div>
    )
}

export default StepTwoUserInfo
